import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20grass%20sports%20competition%20arena%20with%20athletes%20in%20action%20on%20vibrant%20green%20field%2C%20dramatic%20golden%20hour%20lighting%2C%20abstract%20artistic%20style%20with%20soft%20gradients%2C%20clean%20minimal%20composition%2C%20atmospheric%20depth%2C%20warm%20green%20and%20gold%20tones%2C%20no%20text%20or%20logos&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="一起草每日大赛竞技场景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6 py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-300/30 mb-6">
          <i className="ri-fire-line text-accent-400 text-sm"></i>
          <span className="text-sm text-accent-200 font-medium">今日赛事已开启 · 已有 3,286 人参与</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          每天挑战
          <br />
          <span className="text-accent-400">赢取丰厚奖励</span>
        </h1>

        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          一起草每日大赛 — 专为草类竞技爱好者打造的每日在线赛事平台。
          公平竞技、实时排名、丰厚奖励，与全国玩家同台竞技，展示你的实力！
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/caodi-jingji"
            className="w-full sm:w-auto px-8 py-4 bg-primary-500 text-background-50 rounded-lg text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            立即报名参赛
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-lg text-base font-semibold hover:bg-background-50/25 transition-all cursor-pointer border border-background-50/20 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { value: '32+', label: '覆盖城市' },
            { value: '50,000+', label: '注册选手' },
            { value: '120万', label: '总奖金池' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-display font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}